module.exports = __webpack_public_path__ + "img/logo.22af32dd.png";